module.exports = __webpack_public_path__ + "static/img/m1.f8f5b44.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/center/m1.png
// module id = p8tu
// module chunks = 0